import * as React from "react";
import modal from "./modal";
import "./style/index.scss";

interface IDialog {
  content: any;
  className?: string;
  title: string;
  onCancel?: any;
  onClose?: any;
  onOK?: any;
  width?: string;
  isShow?: boolean;
  footer?: any;
  cancelText?: string;
  okText?: string;
  mask?: boolean;
  wrapClassName?: string;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  maskClosable?: boolean;
}
// wrapClassName="vertical-center-modal"

class Dialog {
  // confirm 弹窗content
  private content: any;
  // confirm弹窗的类样式名
  private className: string;
  // confirm 弹窗标题
  private title: string;
  // confirm 弹窗当前自己的对象
  private antConfirm: any;
  // confirm 弹窗宽度
  private width?: string;
  private isShow?: boolean;
  private footer?: any;
  private cancelText?: string;
  private okText?: string;
  private onCancel?: any;
  private onOK?: any;
  private onClose?: any;
  private mask?: boolean;
  private wrapClassName?: string;
  private style?: React.CSSProperties;
  private bodyStyle?: React.CSSProperties;
  private maskClosable?: boolean;

  constructor(m: IDialog) {
    this.content = m.content;
    this.className = m.className ? `${m.className} xy-confirm-body` : "xy-confirm-body";
    this.title = m.title;
    this.antConfirm = "";
    this.width = m.width || "360px";
    this.isShow = m.isShow === undefined ? true : m.isShow;
    this.footer = m.footer || null;
    this.cancelText = m.cancelText || "取消";
    this.okText = m.okText || "确定";
    this.onCancel = m.onCancel || this.hide.bind(this);
    this.onClose = m.onClose || null;
    this.onOK = m.onOK || null;
    this.mask = m.mask;
    this.wrapClassName = m.wrapClassName || "vertical-center-modal";
    this.style = m.style;
    this.bodyStyle = m.bodyStyle;
    this.maskClosable = m.maskClosable || false;

    this.hide = this.hide.bind(this);
    if (this.isShow) {
      this.show();
    }
  }

  // 调用show，创建一个confirm弹窗
  public show() {
    const config = {
      className: this.className,
      content: this.content,
      iconClassName: "",
      iconType: "",
      onCancel: this.onCancel,
      onOk: this.onOK,
      title: this.title,
      width: this.width,
      cancelText: this.cancelText,
      okText: this.okText,
      mask: this.mask,
      wrapClassName: this.wrapClassName,
      style: this.style,
      bodyStyle: this.bodyStyle,
      maskClosable: this.maskClosable
    };
    if (!this.footer) {
      Object.assign(config, { footer: this.footer });
    }
    this.antConfirm = modal(config);
  }

  // 关闭confrim弹窗，并且重新设置mask的显示次序
  public hide() {
    this.antConfirm.destroy();
    if (this.onClose) {
      this.onClose();
    }
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/pc/component/dialog/index.tsx